export const TRANSLATION_LANGUAGE_NAMES: Record<string, string> = {
  ar: 'Arabic',
  cs: 'Czech',
  da: 'Danish',
  de: 'German',
  en: 'English',
  es: 'Spanish',
  fi: 'Finnish',
  fr: 'French',
  hu: 'Hungarian',
  it: 'Italian',
  ja: 'Japanese',
  ko: 'Korean',
  nl: 'Dutch',
  no: 'Norwegian',
  pl: 'Polish',
  pt: 'Portuguese',
  ro: 'Romanian',
  ru: 'Russian',
  sk: 'Slovak',
  sv: 'Swedish',
  tr: 'Turkish',
  uk: 'Ukrainian',
  zh: 'Chinese',
};

export const LANGUAGE_COUNTRY_CODES: Record<string, string> = {
  ar: 'sa',
  cs: 'cz',
  da: 'dk',
  de: 'de',
  en: 'gb',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  hu: 'hu',
  it: 'it',
  ja: 'jp',
  ko: 'kr',
  nl: 'nl',
  no: 'no',
  pl: 'pl',
  pt: 'pt',
  ro: 'ro',
  ru: 'ru',
  sk: 'sk',
  sv: 'se',
  tr: 'tr',
  uk: 'ua',
  zh: 'cn',
};

// Maps language codes to flag emojis via regional indicator symbols derived from LANGUAGE_COUNTRY_CODES.
export const LANGUAGE_FLAG_EMOJIS: Record<string, string> = Object.fromEntries(
  Object.entries(LANGUAGE_COUNTRY_CODES).map(([langCode, countryCode]) => [
    langCode,
    Array.from(countryCode.toUpperCase())
      .map((letter) =>
        String.fromCodePoint(0x1f1e6 + letter.charCodeAt(0) - 65),
      )
      .join(''),
  ]),
);

export const VALID_BOT_LANGUAGES = [
  ['af', 'Afrikaans'],
  ['am', 'Amharic'],
  ['ar', 'Arabic'],
  ['az', 'Azerbaijani'],
  ['be', 'Belarusian'],
  ['bg', 'Bulgarian'],
  ['bn', 'Bengali'],
  ['bo', 'Tibetan standard'],
  ['ca', 'Catalan'],
  ['cs', 'Czech'],
  ['cy', 'Welsh'],
  ['da', 'Danish'],
  ['de', 'German'],
  ['ee', 'Ewe'],
  ['en', 'English'],
  ['eo', 'Esperanto'],
  ['es', 'Spanish'],
  ['et', 'Estonian'],
  ['eu', 'Basque'],
  ['fa', 'Persian'],
  ['fi', 'Finnish'],
  ['fo', 'Faroese'],
  ['fr', 'French'],
  ['ga', 'Irish'],
  ['gl', 'Galician'],
  ['gu', 'Gujarati'],
  ['gr', 'Greek'],
  ['he', 'Hebrew'],
  ['hi', 'Hindi'],
  ['hr', 'Croatian'],
  ['hu', 'Hungarian'],
  ['hy', 'Armenian'],
  ['ia', 'Interlingua'],
  ['id', 'Indonesian'],
  ['is', 'Icelandic'],
  ['it', 'Italian'],
  ['ja', 'Japanese'],
  ['ka', 'Georgian'],
  ['ki', 'Kikuyu'],
  ['km', 'Khmer'],
  ['kn', 'Kannada'],
  ['ko', 'Korean'],
  ['lg', 'Ganda'],
  ['lo', 'Lao'],
  ['lt', 'Lithuanian'],
  ['lv', 'Latvian'],
  ['mk', 'Macedonian'],
  ['ml', 'Malayalam'],
  ['mr', 'Marathi'],
  ['ms', 'Malay'],
  ['mt', 'Maltese'],
  ['my', 'Burmese'],
  ['nb', 'Norwegian bokmal'],
  ['ne', 'Nepali'],
  ['nl', 'Dutch'],
  ['nn', 'Norwegian nynorsk'],
  ['no', 'Norwegian'],
  ['or', 'Oriya'],
  ['pl', 'Polish'],
  ['pt', 'Portuguese'],
  ['rm', 'Romansh'],
  ['ro', 'Romanian'],
  ['ru', 'Russian'],
  ['se', 'Northern sami'],
  ['sk', 'Slovak'],
  ['sl', 'Slovene'],
  ['sn', 'Shona'],
  ['sq', 'Albanian'],
  ['sr', 'Serbian'],
  ['sv', 'Swedish'],
  ['ta', 'Tamil'],
  ['te', 'Telugu'],
  ['th', 'Thai'],
  ['ti', 'Tigrinya'],
  ['tl', 'Tagalog'],
  ['tr', 'Turkish'],
  ['uk', 'Ukrainian'],
  ['ur', 'Urdu'],
  ['vi', 'Vietnamese'],
  ['zh', 'Chinese'],
];
